<div class="toast-box">
  <div class="toast-text">
    <h3 class="toast-title">{{ title }}</h3>
    <div class="toast-body" [innerHTML]="html"></div>
  </div>

  <button class="toast-action" (click)="reload()">
    RELOAD
  </button>
</div>


